import type { SVGProps } from 'react';

const PublicAnnuncementSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 10.0019C18 9.1951 17.0938 8.72029 16.4307 9.17961L11 12.9423V18.9423L16.4307 22.705C17.0938 23.164 17.9998 22.6893 18 21.8827V17.9427C19.1046 17.9427 20 17.0473 20 15.9427C20 14.8382 19.1046 13.9427 18 13.9427V10.0019ZM6 18.9423H9V12.9423H6C5.44784 12.9423 5.0002 13.3902 5 13.9423V17.9423C5 18.4946 5.44772 18.9423 6 18.9423ZM23.7489 10.1938C24.0836 9.85907 24.6263 9.85907 24.961 10.1938C28.1361 13.3689 28.1361 18.5166 24.961 21.6917C24.6263 22.0264 24.0836 22.0264 23.7489 21.6917C23.4141 21.357 23.4141 20.8143 23.7489 20.4795C26.2544 17.9739 26.2544 13.9116 23.7489 11.406C23.4141 11.0712 23.4141 10.5285 23.7489 10.1938ZM21.0304 12.9122C21.3652 12.5775 21.9079 12.5775 22.2426 12.9122C23.9163 14.5859 23.9163 17.2995 22.2426 18.9732C21.9079 19.3079 21.3652 19.3079 21.0304 18.9732C20.6957 18.6384 20.6957 18.0957 21.0304 17.761C22.0346 16.7568 22.0346 15.1286 21.0304 14.1244C20.6957 13.7897 20.6957 13.247 21.0304 12.9122ZM9 18.9427L10 23.9427H8L7 18.9427H9Z"
      fill="#333333"
    />
  </svg>
);
export default PublicAnnuncementSvgIcon;
